import { cn, getLocaleAsset } from "@tosize/ui";
import { type ComponentProps, Fragment } from "react";

export function SmallBackgroundImage(props: Omit<Props, "width" | "column">) {
	const { variant = "default", className, ...restProps } = props;

	return (
		<div
			className={cn(className, "h-auto w-full bg-cover", {
				"min-h-[6rem]": variant === "default",
				"min-h-[10rem]": variant === "floating",
			})}
			style={{
				backgroundImage: `url('${getLocaleAsset("categorie/klantenservice_achtergrond.png")}')`,
			}}
			{...restProps}
		/>
	);
}

interface Props extends ComponentProps<"div"> {
	width?: "default" | "lg";
	column?: "single" | "multiple" | "none";
	variant?: "floating" | "default";
}

export function SmallBackgroundLayout(props: Props) {
	const {
		width = "default",
		column = "multiple",
		variant = "default",
		className,
		...restProps
	} = props;

	return (
		<Fragment>
			<SmallBackgroundImage variant={variant} />

			<div className={cn("container", { "xl:max-w-screen-xl": width === "lg" })}>
				<div
					className={cn(
						{
							"odd:*:pb-4 even:*:pt-4 sm:even:*:pt-8 sm:odd:*:pb-8 lg:even:*:pt-0 lg:even:*:pl-12 lg:odd:*:pr-12 lg:odd:*:pb-0 xl:even:*:pl-16 xl:odd:*:pr-16":
								column === "multiple",
							"divide-y-2 divide-shades-medium-light lg:divide-x-2 lg:divide-y-0":
								column === "multiple",
							"grid lg:grid-cols-2": column !== "none",
							"-mt-16 rounded-t-xl bg-white p-4 sm:p-8 lg:p-12 xl:p-16": variant === "floating",
							"py-4 sm:py-8": variant === "default",
						},
						className,
					)}
					{...restProps}
				/>
			</div>
		</Fragment>
	);
}
